import { NoteManyQuery } from "gql/generated";
import { Center, Flex } from "styled-system/jsx";
import { StaticNoteContent } from "./StaticNoteContent";
import { useState } from "react";
import { EditNoteContent } from "./EditNoteContent";
import { Spinner } from "@ttc3k/trekker";
import { useAuth0 } from "@auth0/auth0-react";

type NoteProps = {
  note?: NoteManyQuery["noteMany"][0];
  viewOnly?: boolean;
  onEditSave?: (message: string) => void;
  onDeleteNote?: () => void;
  onResolveNoteClick?: () => void;
  onCancelEditing?: () => void;
  loading?: boolean;
};

export const Note = ({
  note,
  viewOnly = false,
  onEditSave,
  onResolveNoteClick,
  onDeleteNote,
  onCancelEditing,
  loading = false,
}: NoteProps) => {
  const [isEditing, setIsEditing] = useState(false);

  const { user } = useAuth0();

  const isNoteResolved = !!note?.resolvedBy;
  const isCreatingNewNote = !note;
  const isEditingOrCreatingNote = isEditing || isCreatingNewNote;

  // When editing a note, only allow users who are the author of the note to
  // edit it
  const canUserEditNote = !isCreatingNewNote
    ? !!user &&
      !!user.email &&
      !!note &&
      !!note.author &&
      !!note.author.email &&
      user.email === note.author.email
    : true;

  const handleCancelEditing = () => {
    onCancelEditing?.();
    setIsEditing(false);
  };
  return (
    <Flex
      flexDir={"column"}
      gap={"300"}
      justifyContent={"space-between"}
      backgroundColor={
        isNoteResolved ? "bg.success.lightest" : "bg.highlight.lightest"
      }
      borderRadius={"100"}
      borderWidth={"1px"}
      borderStyle={"solid"}
      borderColor={isNoteResolved ? "border.success" : "border.highlight"}
      p={"300"}
      minW={"370px"}
      minH={"212px"}
      w={"full"}
    >
      {loading && (
        <Center h={"full"}>
          <Spinner w={"40px"} h={"40px"} />
        </Center>
      )}
      {!isEditingOrCreatingNote && note && !loading && (
        <StaticNoteContent
          note={note}
          viewOnly={viewOnly}
          onEditClick={
            onEditSave && canUserEditNote ? () => setIsEditing(true) : undefined
          }
          onResolveNoteClick={onResolveNoteClick}
        />
      )}
      {!viewOnly &&
        isEditingOrCreatingNote &&
        onEditSave &&
        !loading &&
        canUserEditNote && (
          <EditNoteContent
            note={note}
            viewOnly={viewOnly}
            onEditSave={onEditSave}
            onDeleteNote={onDeleteNote}
            onCloseEditing={handleCancelEditing}
          />
        )}
    </Flex>
  );
};
